import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { toast } from '@/hooks/useToast';
import { nieuweId } from '@/lib/melden/id';
import { api, formatApiError } from '@/lib/api';
import { MeldingGesprek } from './MeldingGesprek';

/**
 * P5 after sending: thanks, the fixed sentence that this is an AI assistant
 * (AI Act art. 50 lid 1), "Spreek een mens", and the conversation polling for
 * an answer while the panel is open.
 */
export function MeldingVerstuurd({ externalId }: { externalId: string }) {
  const { t } = useTranslation();
  const [mensId] = useState(() => nieuweId());
  const [mensGevraagd, setMensGevraagd] = useState(false);
  const mens = useMutation({
    mutationFn: () => api.meldingen.bericht(externalId, { external_id: mensId, soort: 'wil_mens', tekst: '', bijlagen: [] }),
    onSuccess: () => setMensGevraagd(true),
    onError: (e) => toast.error(t('melden.fout'), { description: formatApiError(e, t('melden.fout')) }),
  });
  return (
    <div className="mt-3">
      <p className="text-[14px] font-medium text-text-primary">{t('melden.verstuurd')}</p>
      <p className="mt-1 text-[13px] text-text-secondary">{t('melden.ai')}</p>
      {mensGevraagd ? (
        <output className="mt-2 block text-[13px] text-text-secondary">{t('melden.mensGevraagd')}</output>
      ) : (
        <button
          type="button"
          disabled={mens.isPending}
          onClick={() => mens.mutate()}
          className="mt-2 h-8 rounded-sm border border-border bg-bg-secondary px-3 text-[13px] font-medium text-text-primary hover:border-border-strong disabled:opacity-60"
        >
          {t('melden.mens')}
        </button>
      )}
      <MeldingGesprek externalId={externalId} poll />
    </div>
  );
}
